import { isEnv } from 'hb-react/shared/utils/env';
import isValueEmpty from 'hb-react/shared/utils/isValueEmpty';

export const errorMessage = __('Must be valid');

export const validateRegex = (
  value,
  regex,
  defaultErrorMessage = errorMessage,
) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  try {
    if (!regex.test(value)) {
      error = defaultErrorMessage;
    }
  } catch {
    if (isEnv('development', 'test')) {
      // eslint-disable-next-line no-console
      console.warn('[HB-React] Invalid regex');
    }
  }

  return error;
};
